import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import VueMeta from 'vue-meta'

// global styles
import './assets/main.css'

createApp(App).use(router).mount('#app')
//Vue.use(VueMeta)